var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Button } from '../../elements';
import { T } from '../../helpers/i18n';
import cxs from 'cxs/component';
import theme from '../../Theme';
import PropTypes from 'prop-types';
export var PrintRefund = function (_a) {
    var ticket = _a.ticket, onPrint = _a.onPrint, onRefund = _a.onRefund, onClickChangeDatebook = _a.onClickChangeDatebook;
    return (React.createElement("div", { className: "btn-detail", style: { flexDirection: 'row', justifyContent: 'space-evenly' } },
        React.createElement(WrapperButton, { primary: true, onClick: onPrint ? onPrint : function () { window.print(); } }, T('print')),
        React.createElement(WrapperButton, { primary: true, 
            /*disabled={ticket.daterefund!== null || ticket.refund_id !== null}*/
            style: { alignContent: 'end' }, onClick: function () { return onRefund(ticket); } }, T('refund')),
        React.createElement(WrapperButton, { primary: true, onClick: function () {
                if (ticket.daterefund || ticket.refund_id) {
                    return alert(T('canceledNoModified'));
                }
                onClickChangeDatebook();
            } }, T('changeDatebook'))));
};
var WrapperButton = cxs(Button)(function (_a) {
    var primary = _a.primary;
    return __assign(__assign(__assign({}, primary ? { color: theme.color.primary } : undefined), { margin: '0.29rem', fontSize: 'small' }), theme.border);
});
WrapperButton.propTypes = {
    primary: PropTypes.bool
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/PrintRefund.tsx
// module id = 487
// module chunks = 0